<template>
  <div class="error-container">
    <div v-if="isDev" class="error-card">
      <h1 class="error-status-code">{{ error.statusCode }}</h1>
      <p class="error-message">{{ error.statusMessage || 'An unexpected error occurred.' }}</p>
      <p class="error-stack">
        {{ error.stack }}
      </p>
      <button class="error-button" @click="handleError">Go Back to Homepage</button>
    </div>
    <PageNotFound />
  </div>
</template>

<script setup>
import PageNotFound from './pages/PageNotFound';

defineProps({
  error: {
    type: Object,
    required: true,
  },
});

const isDev = import.meta.dev;

const handleError = () => clearError({ redirect: '/' });
</script>

<style scoped>
.error-container {
  text-align: center;
  padding: 4rem;
}
</style>
